<template>
    <div>
        <h5 style="margin-top: 10px;font-weight: bold;font-size: 14px;">
            {{ title }}
        </h5>
        <div style="background-color: #f5f7fa;padding: 10px;border-radius: 4px; margin-top: 10px;" v-for="(item, index) in list" :key="index">
            <p>{{ item.app }}</p>
            <p>{{ item.unique_app }}</p>
            <p style="text-indent: 1rem;">{{ item.user }}</p>
            <p style="padding-left: 1rem;" v-if="item?.customer?.length > 0">绑定客户<span style="color: #ff0000;">（拥有产品绑定的客户归属的账户权限，即可使用该产品，账户权限请联系组长绑定或授权）</span></p>
            <div style="padding-left: 1rem" v-for="(itemc, indexc) in item?.customer" :key="indexc">
                <p>{{ itemc.customer_info }}</p>
                <p style="padding-left: 1rem;" v-for="(itema, indexa) in itemc.account_list" :key="indexa">{{ itema }}</p>
            </div>
            <p style="padding-left: 1rem;color: #ff0000;" v-if="!item.customer || item.customer.length == 0">
                当前产品与绑定的客户无投放账户，目前仅录入人可使用该产品，若产品负责人已变更请联系产品协助调整。
            </p>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ErrorItems',
    props: {
        title: {
            type: String,
            default: '重复类型：与录入产品重复'
        },
        list: {
            type: Array,
            default: () => [
                // {
                //     "app": "录入产品：OPPO-2（ID：1）（包名：1）",
                //     "unique_app": "重复产品：OPPO-1（ID：1）（包名：2）",
                //     "user": "录入人：aaa（超级管理员）",
                //     "customer": [
                //         {
                //             "customer_info": "客户：（101362）上海沐瞳科技有限公司",
                //             "account_list": [
                //                 "账户：(1000294768)上海沐瞳科技有限公司-hsymxOPPO01-幻世与冒险",
                //                 "账户：(1000294769)上海沐瞳科技有限公司-hsymxOPPO02-幻世与冒险",
                //                 "账户：(1000294770)上海沐瞳科技有限公司-hsymxOPPO03-幻世与冒险",
                //                 "账户：(1000294771)上海沐瞳科技有限公司-hsymxOPPO04-幻世与冒险",
                //                 "账户：(1000294772)上海沐瞳科技有限公司-hsymxOPPO05-幻世与冒险",
                //                 "账户：(1000407526)上海沐瞳科技有限公司-CXswzoppo001-潮汐守望者",
                //                 "账户：(1000407874)上海沐瞳科技有限公司-CXswzoppo002-潮汐守望者",
                //                 "账户：(1000407878)上海沐瞳科技有限公司-CXswzoppo003-潮汐守望者",
                //                 "账户：(1000407881)上海沐瞳科技有限公司-CXswzoppo004-潮汐守望者",
                //                 "账户：(1000407885)上海沐瞳科技有限公司-CXswzoppo005-潮汐守望者",
                //                 "账户：(1000407886)上海沐瞳科技有限公司-CXswzoppo006-潮汐守望者",
                //                 "账户：(1000469302)上海沐瞳科技有限公司-jsdfOPPO01-决胜巅峰",
                //                 "账户：(1000469303)上海沐瞳科技有限公司-jsdfOPPO02-决胜巅峰",
                //                 "账户：(1000469305)上海沐瞳科技有限公司-jsdfOPPO03-决胜巅峰",
                //                 "账户：(1000469306)上海沐瞳科技有限公司-jsdfOPPO04-决胜巅峰",
                //                 "账户：(1000469308)上海沐瞳科技有限公司-jsdfOPPO05-决胜巅峰"
                //             ]
                //         }
                //     ]
                // }
            ]
        }
    }
}
</script>